import * as React from "react";
import { Link as ReactRouterLink } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { Breadcrumbs } from "@graffer-inc/console-design-kit";
import { BrowserTemplate } from "../base-template";
import { SettingsMenuList } from "../../organisms/settings/menu-list";

export const SettingsTemplate: React.FC<{
  children: React.ReactNode;
  breadcrumbs: Array<{ to: string; title: string }>;
}> = ({ breadcrumbs, children }) => {
  return (
    <div id="rootWrapper">
      <BrowserTemplate title="設定・サポート">
        <div className="wrapper">
          <div id="pageWrapper" className="columns" style={{ margin: 0 }}>
            <SettingsMenuList />
            <div className="column is-content-pane main">
              <Breadcrumbs
                list={breadcrumbs}
                anchor={({ href = "", ...props }) => (
                  <ReactRouterLink {...props} to={href} />
                )}
              />
              {children}
            </div>
          </div>
        </div>
      </BrowserTemplate>
    </div>
  );
};
